<script>
import Service from '@/services/jetty';
import CommonConstants from '@/common/Constants';
import Utils from '@/common/Utils';
import JettyUllageProductField from '@/components/jetty/JettyUllageProductField.vue';


export default {
  props: ['id'],
  components: { JettyUllageProductField },
  data() {
    return {
      loading: false,
      data: {},

      config: {
        ASTM54A: {
          density15: 'kg/l',
          tov: 'm³',
          freeWater: 'm³',
          averageTemperature: '°C',
          gov: 'm³',
          gsv: 'm³',
          sedimentsAndWater: 'm³',
          nsv: 'm³',
          obq: 'Tons',
          vef: '-',
          weightInAir: 'Tons',
          netWeight: 'Tons',

          ullage: 'cm',
          freeWaterInnage: 'cm',
          freeWaterVolume: 'm³',
          temperature: '°C',
          vcf: 'ASTM54A'
        },
        ASTM54B: {
          density15: 'kg/l',
          tov: 'm³',
          freeWater: 'm³',
          averageTemperature: '°C',
          gov: 'm³',
          gsv: 'm³',
          sedimentsAndWater: 'm³',
          nsv: 'm³',
          obq: 'Tons',
          vef: '-',
          weightInAir: 'Tons',
          netWeight: 'Tons',

          ullage: 'mm',
          freeWaterInnage: 'm',
          freeWaterVolume: 'm³',
          temperature: '°C',
          vcf: 'ASTM54A'
        },
        POME: {
          density15: 'kg/l',
          tov: 'm³',
          vef: '-',
          weightInAir: 'Tons',

          ullage: 'm',
          temperature: '°C',
          vcf: 'kg/m³x°C'
        },

        XILENE: {
          density15: 'kg/l',
          tov: 'm³',
          freeWater: 'm³',
          averageTemperature: '°C',
          gov: 'm³',
          gsv: 'm³',
          sedimentsAndWater: 'm³',
          nsv: 'm³',
          vef: '-',
          weightInAir: 'Tons',

          ullage: 'm',
          freeWaterInnage: 'm',
          freeWaterVolume: 'm³',
          temperature: '°C',
          vcf: 'ASTM54C'
        },
        TOLUENE: {
          density15: 'kg/l',
          tov: 'm³',
          freeWater: 'm³',
          averageTemperature: '°C',
          gov: 'm³',
          gsv: 'm³',
          sedimentsAndWater: 'm³',
          nsv: 'm³',
          vef: '-',
          weightInAir: 'Tons',

          ullage: 'm',
          freeWaterInnage: 'm',
          freeWaterVolume: 'm³',
          temperature: '°C',
          vcf: 'ASTM54C'
        },
        BENZENE: {
          density15: 'kg/l',
          tov: 'm³',
          freeWater: 'm³',
          gov: 'm³',
          gsv: 'm³',
          sedimentsAndWater: 'm³',
          nsv: 'm³',
          vef: '-',
          weightInAir: 'Tons',

          ullage: 'm',
          freeWaterInnage: 'm',
          freeWaterVolume: 'm³',
          temperature: '°C',
          vcf: 'ASTM54C'
        },
        ACIDO: {
          density15: 'kg/l (air)',
          tov: 'm³',
          vef: '-',
          weightInAir: 'Tons',

          ullage: 'm',
          temperature: '°C',
          vcf: '-'
        },
        METANOLO: {
          density20: 'kg/l  ',
          tov: 'm³',
          vef: '-',
          weightInAir: 'Tons',

          ullage: 'm',
          temperature: '°C',
          vcf: '-'
        },

        ETILBENZENE: {
          density15: 'kg/l',
          tov: 'm³',
          freeWater: 'm³',
          gov: 'm³',
          vef: '-',
          weightInAir: 'Tons',

          ullage: 'm',
          freeWaterInnage: 'm',
          freeWaterVolume: 'm³',
          temperature: '°C',
          vcf: '-'
        },
        CUMENE: {
          density15: 'kg/l',
          tov: 'm³',
          freeWater: 'm³',
          averageTemperature: '°C',
          gov: 'm³',
          gsv: 'm³',
          sedimentsAndWater: 'm³',
          nsv: 'm³',
          obq: 'Tons',
          vef: '-',
          weightInAir: 'Tons',
          netWeight: 'Tons',

          ullage: '',
          freeWaterInnage: 'm',
          freeWaterVolume: 'm³',
          temperature: '°C',
          vcf: 'ASTMD1555'
        },

        ETILENE: {
          tankVolume: 'm³',
          level: 'm',
          pressure: 'kg/cm2',
          liquidTemperature: '°C',
          liquidShrinkageFactor: ' ',
          liquidDensity: 'kg/m³',
          liquidVolume: 'm³',
          liquidWeight: 'Tons',
          steamTemperature: '°C',
          steamShrinkageFactor: ' ',
          molecularWeight: 'kg/mol',
          steamVolume: 'm³',
          steamWeight: 'Tons',

          totalCorrectedLiquidVolume: 'm³',
          totalCorrectedSteamVolume: 'm³',
          totalLiquidWeight: 'Tons',
          totalSteamWeight: 'Tons',
          totalWeight: 'Tons',

          totalCorrectedLiquidVolumeBefore: 'm³',
          totalCorrectedSteamVolumeBefore: 'm³',
          totalLiquidWeightBefore: 'Tons',
          totalSteamWeightBefore: 'Tons',
          totalWeightBefore: 'Tons'
        },

        LPG: {
          tankVolume: 'm³',
          level: 'mM',
          pressure: 'kg/cm2',
          liquidTemperature: '°C',
          liquidShrinkageFactor: ' ',
          liquidDensity: 'kg/m³',
          liquidVolumeObserved: 'm³',
          vcf: 'ASTM54',
          liquidVolume: 'm³',
          liquidWeight: 'Tons',


          steamTemperature: '°C',
          steamShrinkageFactor: ' ',
          molecularWeight: 'kg/mol',
          steamVolume: 'm³',
          steamDensity: 'kg/m³',
          steamWeight: 'Tons',

          totalCorrectedLiquidVolume: 'm³',
          totalCorrectedSteamVolume: 'm³',
          totalLiquidWeight: 'Tons',
          totalSteamWeight: 'Tons',
          totalWeight: 'Tons',

          totalCorrectedLiquidVolumeBefore: 'm³',
          totalCorrectedSteamVolumeBefore: 'm³',
          totalLiquidWeightBefore: 'Tons',
          totalSteamWeightBefore: 'Tons',
          totalWeightBefore: 'Tons'
        }
      }
    }
  },
  computed: {
    constants() {
      return CommonConstants;
    },
    utils() {
      return Utils;
    },
    uiPermissions() {
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created() {
    this.load();
  },
  mounted() {
    this.$store.dispatch('security/setNavbarTitle', 'JettyUllage.page_title');
  },
  watch: {
  },
  methods: {
    load() {
      this.loading = true;
      Service.getUllage(this.id, response => {
        this.loading = false;
        if (response.success) {
          this.data = response.data;
          this.data.ullageDate = Utils.dateToCurrentTimeZone(this.data.ullageDate);
        }
      });
    }
  }
}

</script>

<template>
  <main>
    <div class="">
      <Card class="m-2">
        <template #content>
          <div class="grid">
            <div class="col-6 grid">
              <div class="col-12 lg:col-4">
                <label>{{ $t('vessel.fk') }}</label>
                <InputText disabled v-model="data.registryVessel" :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
              </div>
              <div class="col-12 lg:col-4">
                <label>{{ $t('JettyUllage.berthNumber') }}</label>
                <InputText disabled v-model="data.berthNumber" :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
              </div>
              <div class="col-12 lg:col-4">
                <label>{{ $t('JettyUllage.ullageDate') }}</label>
                <Calendar :placeholder="constants.DATE_PLACEHOLDER_POINT" :dateFormat="constants.DATE_FORMAT_POINT"
                  :showTime="false" disabled v-model="data.ullageDate" :showIcon="true" :showButtonBar="true"
                  :yearNavigator="true" :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
              </div>
              <div class="col-12 lg:col-4">
                <label>{{ $t('JettyUllage.from') }}</label>
                <InputText disabled v-model="data.voyageFrom" :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
              </div>
              <div class="col-12 lg:col-4">
                <label>{{ $t('JettyUllage.to') }}</label>
                <InputText disabled v-model="data.voyageTo" :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
              </div>
            </div>
            <div class="col-3 grid">
              <div class="col-12 lg:col-6">
                <label>{{ $t('JettyUllage.draftFore') }}</label>
                <InputText disabled v-model="data.draftFore" :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
              </div>
              <div class="col-12 lg:col-6">
                <label>{{ $t('JettyUllage.draftAfter') }}</label>
                <InputText disabled v-model="data.draftAfter" :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
              </div>
              <div class="col-12 lg:col-6">
                <label>{{ $t('JettyUllage.draftTrim') }}</label>
                <InputText disabled v-model="data.draftTrim" :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
              </div>
              <div class="col-12 lg:col-6">
                <label>{{ $t('JettyUllage.list') }}</label>
                <InputText disabled v-model="data.list" :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
              </div>
            </div>
            <div class="col-3">
              <div class="grid">
                <div class="col-4" />
                <div class="col-4 field">Before</div>
                <div class="col-4 field">After</div>
              </div>
              <div class="grid">
                <div class="col-4 field">Loading</div>
                <div class="col-4 field">
                  <Checkbox v-model="data.beforeLoading" :binary="true" disabled />
                </div>
                <div class="col-4 field">
                  <Checkbox v-model="data.afterLoading" :binary="true" disabled />
                </div>
              </div>
              <div class="grid">
                <div class="col-4 field">Discharging</div>
                <div class="col-4 field">
                  <Checkbox v-model="data.beforeDischarging" :binary="true" disabled />
                </div>
                <div class="col-4 field">
                  <Checkbox v-model="data.afterDischarging" :binary="true" disabled />
                </div>
              </div>
            </div>
          </div>
        </template>
      </Card>
      <div class="grid m-1">
        <div class="col-9">
          <DataTable style="height: 26vw" :loading="loading" :reorderableColumns="true"
            v-for="p in data.ullageVoyageProducts" :key="p.id" :value="p.ullageVoyageProductDetails" :lazy="true"
            showGridlines stripedRows ref="dt" :resizableColumns="true" columnResizeMode="expand">
            <Column :header="$t('JettyUllage.tank')" field="tankNumber" />
            <Column :header="`${$t('JettyUllage.tankVolume')} (${config[data.developmentType].tankVolume})`"
              field="tankVolume" v-if="config[data.developmentType].tankVolume">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 3) }}
              </template>
            </Column>
            <Column :header="$t('JettyUllage.gradeName')">
              <template #body>
                {{ p.gradeName }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.ullage')} (${config[data.developmentType].ullage})`" field="ullage"
              v-if="config[data.developmentType].ullage">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 2) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.tov')} (${config[data.developmentType].tov})`" field="tov"
              v-if="config[data.developmentType].tov">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 2) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.freeWaterInnage')} (${config[data.developmentType].freeWaterInnage})`"
              field="freeWaterString" v-if="config[data.developmentType].freeWaterInnage">
              <template #body="{ data, field }">
                {{ data[field] }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.freeWaterVolume')} (${config[data.developmentType].freeWaterVolume})`"
              field="freeWaterVolume" v-if="config[data.developmentType].freeWaterVolume">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 3) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.temperature')} (${config[data.developmentType].temperature})`"
              field="temperature" v-if="config[data.developmentType].temperature">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 2) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.density15')} (${config[data.developmentType].density15})`"
              v-if="config[data.developmentType].density15">
              <template #body>
                {{ p.density }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.density20')} (${config[data.developmentType].density20})`"
              v-if="config[data.developmentType].density20">
              <template #body>
                {{ p.density }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.gov')} (${config[data.developmentType].gov})`" field="gov"
              v-if="config[data.developmentType].gov">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 3) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.level')} (${config[data.developmentType].level})`" field="level"
              v-if="config[data.developmentType].level">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 3) }}
              </template>
            </Column>
            <Column
              :header="`${$t('JettyUllage.liquidTemperature')} (${config[data.developmentType].liquidTemperature})`"
              field="liquidTemperature" v-if="config[data.developmentType].liquidTemperature">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 2) }}
              </template>
            </Column>
            <Column
              :header="`${$t('JettyUllage.liquidShrinkageFactor')} (${config[data.developmentType].liquidShrinkageFactor})`"
              field="liquidShrinkageFactor" v-if="config[data.developmentType].liquidShrinkageFactor">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 6) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.liquidDensity')} (${config[data.developmentType].liquidDensity})`"
              field="liquidDensity" v-if="config[data.developmentType].liquidDensity">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 6) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.vcf')} (${config[data.developmentType].vcf})`" field="vcf"
              v-if="config[data.developmentType].vcf">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 5) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.liquidVolume')} (${config[data.developmentType].liquidVolume})`"
              field="liquidVolume" v-if="config[data.developmentType].liquidVolume">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 3) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.liquidWeight')} (${config[data.developmentType].liquidWeight})`"
              field="liquidWeight" v-if="config[data.developmentType].liquidWeight">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 3) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.gsv')} (${config[data.developmentType].gsv})`" field="gsv"
              v-if="config[data.developmentType].gsv">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 3) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.weightInAir')} (${config[data.developmentType].weightInAir})`"
              field="weightInAir" v-if="config[data.developmentType].weightInAir">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 3) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.pressure')} (${config[data.developmentType].pressure})`"
              field="pressure" v-if="config[data.developmentType].pressure">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 2) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.steamTemperature')} (${config[data.developmentType].steamTemperature})`"
              field="steamTemperature" v-if="config[data.developmentType].steamTemperature">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 2) }}
              </template>
            </Column>
            <Column
              :header="`${$t('JettyUllage.steamShrinkageFactor')} (${config[data.developmentType].steamShrinkageFactor})`"
              field="steamShrinkageFactor" v-if="config[data.developmentType].steamShrinkageFactor">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 6) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.molecularWeight')} (${config[data.developmentType].molecularWeight})`"
              field="molecularWeight" v-if="config[data.developmentType].molecularWeight">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 2) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.steamVolume')} (${config[data.developmentType].steamVolume})`"
              field="steamVolume" v-if="config[data.developmentType].steamVolume">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 3) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.steamDensity')} (${config[data.developmentType].steamDensity})`"
              field="steamDensity" v-if="config[data.developmentType].steamDensity">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 6) }}
              </template>
            </Column>
            <Column :header="`${$t('JettyUllage.steamWeight')} (${config[data.developmentType].steamWeight})`"
              field="steamWeight" v-if="config[data.developmentType].steamWeight">
              <template #body="{ data, field }">
                {{ utils.formatDecimal(data[field], 3) }}
              </template>
            </Column>
            <template #empty>
              {{ $t('noRecordsFound') }}
            </template>
          </DataTable>
        </div>
        <div class="col-3">
          <Card class="" v-for="p in data.ullageVoyageProducts" :key="p.id">
            <template #content>
              <JettyUllageProductField :label="$t('JettyUllage.gradeName')" uom="" :value="p.registryProduct"
                :hideUom="true" />
              <JettyUllageProductField v-if="config[data.developmentType].density15"
                :label="$t('JettyUllage.density15')" :uom="config[data.developmentType].density15"
                :value="utils.formatDecimal(p.density, 4)" />
              <JettyUllageProductField v-if="config[data.developmentType].density20"
                :label="$t('JettyUllage.density20')" :uom="config[data.developmentType].density15"
                :value="utils.formatDecimal(p.density, 4)" />
              <JettyUllageProductField v-if="config[data.developmentType].tov" :label="$t('JettyUllage.tov')"
                :uom="config[data.developmentType].tov" :value="utils.formatDecimal(p.tov, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].freeWater"
                :label="$t('JettyUllage.freeWater')" :uom="config[data.developmentType].freeWater"
                :value="utils.formatDecimal(p.freeWater, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].averageTemperature"
                :label="$t('JettyUllage.averageTemperature')" :uom="config[data.developmentType].averageTemperature"
                :value="utils.formatDecimal(p.averageTemperature, 2)" />
              <JettyUllageProductField v-if="config[data.developmentType].gov" :label="$t('JettyUllage.gov')"
                :uom="config[data.developmentType].gov" :value="utils.formatDecimal(p.gov, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].gsv" :label="$t('JettyUllage.gsv')"
                :uom="config[data.developmentType].gsv" :value="utils.formatDecimal(p.gsv, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].sedimentsAndWater"
                :label="$t('JettyUllage.sedimentsAndWater')" :uom="config[data.developmentType].sedimentsAndWater"
                :value="utils.formatDecimal(p.sedimentsAndWater, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].nsv" :label="$t('JettyUllage.nsv')"
                :uom="config[data.developmentType].nsv" :value="utils.formatDecimal(p.nsv, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].obq" :label="$t('JettyUllage.obq')"
                :uom="config[data.developmentType].obq" :value="utils.formatDecimal(p.obq, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].vef" :label="$t('JettyUllage.vef')"
                :uom="config[data.developmentType].vef" :value="utils.formatDecimal(p.vef, 5)" />
              <JettyUllageProductField v-if="config[data.developmentType].weightInAir"
                :label="$t('JettyUllage.weightInAir')" :uom="config[data.developmentType].weightInAir"
                :value="utils.formatDecimal(p.weightInAir, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].netWeight"
                :label="$t('JettyUllage.netWeight')" :uom="config[data.developmentType].netWeight"
                :value="utils.formatDecimal(p.netWeight, 3)" />

              <p v-if="data.developmentType == 'ETILENE' || data.developmentType == 'LPG'"><strong>{{
                $t('JettyUllage.quantitiesOnBoard') }}</strong></p>
              <JettyUllageProductField v-if="config[data.developmentType].totalCorrectedLiquidVolume"
                :label="$t('JettyUllage.totalCorrectedLiquidVolume')"
                :uom="config[data.developmentType].totalCorrectedLiquidVolume"
                :value="utils.formatDecimal(p.totalCorrectedLiquidVolume, 6)" />
              <JettyUllageProductField v-if="config[data.developmentType].totalCorrectedSteamVolume"
                :label="$t('JettyUllage.totalCorrectedSteamVolume')"
                :uom="config[data.developmentType].totalCorrectedSteamVolume"
                :value="utils.formatDecimal(p.totalCorrectedSteamVolume, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].totalLiquidWeight"
                :label="$t('JettyUllage.totalLiquidWeight')" :uom="config[data.developmentType].totalLiquidWeight"
                :value="utils.formatDecimal(p.totalLiquidWeight, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].totalSteamWeight"
                :label="$t('JettyUllage.totalSteamWeight')" :uom="config[data.developmentType].totalSteamWeight"
                :value="utils.formatDecimal(p.totalSteamWeight, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].totalWeight"
                :label="$t('JettyUllage.totalWeight')" :uom="config[data.developmentType].totalWeight"
                :value="utils.formatDecimal(p.totalWeight, 3)" />

              <p v-if="data.developmentType == 'ETILENE' || data.developmentType == 'LPG'"><strong>{{
                $t('JettyUllage.quantitiesOnBoardBefore') }}</strong></p>
              <JettyUllageProductField v-if="config[data.developmentType].totalCorrectedLiquidVolumeBefore"
                :label="$t('JettyUllage.totalCorrectedLiquidVolume')"
                :uom="config[data.developmentType].totalCorrectedLiquidVolumeBefore"
                :value="utils.formatDecimal(p.totalCorrectedLiquidVolumeBefore, 6)" />
              <JettyUllageProductField v-if="config[data.developmentType].totalCorrectedSteamVolumeBefore"
                :label="$t('JettyUllage.totalCorrectedSteamVolume')"
                :uom="config[data.developmentType].totalCorrectedSteamVolumeBefore"
                :value="utils.formatDecimal(p.totalCorrectedSteamVolumeBefore, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].totalLiquidWeightBefore"
                :label="$t('JettyUllage.totalLiquidWeight')" :uom="config[data.developmentType].totalLiquidWeightBefore"
                :value="utils.formatDecimal(p.totalLiquidWeightBefore, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].totalSteamWeightBefore"
                :label="$t('JettyUllage.totalSteamWeight')" :uom="config[data.developmentType].totalSteamWeightBefore"
                :value="utils.formatDecimal(p.totalSteamWeightBefore, 3)" />
              <JettyUllageProductField v-if="config[data.developmentType].totalWeightBefore"
                :label="$t('JettyUllage.totalWeight')" :uom="config[data.developmentType].totalWeightBefore"
                :value="utils.formatDecimal(p.totalWeightBefore, 3)" />
            </template>
          </Card>
        </div>
      </div>
      <div class="grid my-3 mx-1">
        <div class="col-12">
          <Card>
            <template #content v-if="data.ullageVoyageNotes && data.ullageVoyageNotes.length > 0">
              <div v-if="data.developmentType == 'ETILENE' || data.developmentType == 'LPG'">
                <div class="grid note-grid">
                  <div class="col-6">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[0].note }}</p>
                  </div>
                  <div class="col-6">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[4].note }}</p>
                  </div>
                  <div class="col-6">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[1].note }}</p>
                  </div>
                  <div class="col-6">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[5].note }}</p>
                  </div>
                  <div class="col-6">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[2].note }}</p>
                  </div>
                  <div class="col-6">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[6].note }}</p>
                  </div>
                  <div class="col-6">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[3].note }}</p>
                  </div>
                  <div class="col-6">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[7].note }}</p>
                  </div>
                </div>
              </div>
              <div v-else-if="data.chargeDischargeFlag == 'D'">
                <div class="grid note-grid">
                  <!--row 1-->
                  <div class="col-1 font-bold">
                    <p>Note</p>
                  </div>
                  <div class="col-3">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[0].note }}</p>
                  </div>
                  <div class="col-1 text-center">
                    <p>M/T</p>
                  </div>
                  <div class="col-1 text-center">
                    <p>%</p>
                  </div>
                  <div class="col-1 font-bold">
                  </div>
                  <div class="col-1 font-bold mid-el">
                    <p>UTI/MMC N°</p>
                  </div>
                  <div class="col-1">
                    <p>{{ data.ullageVoyageNotes[0].surveyorUTINumber }}</p>
                  </div>
                  <div class="col-1 font-bold">
                    <p>Calib. Date</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDate(data.ullageVoyageNotes[0].surveyorUTICalibrationDate) }}</p>
                  </div>
                  <div class="col-1 font-bold">
                    <p>Surveyor</p>
                  </div>
                  <!--row 2-->
                  <div class="col-1 font-bold">
                    <p>B/L Figure M/T</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDecimal(data.ullageVoyageNotes[0].blWeight, 3) }}</p>
                  </div>
                  <div class="col-1">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[2]?.note }}</p>
                  </div>
                  <div class="col-1">
                    <p>M/T</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDecimal(data.ullageVoyageNotes[0].blArrivalDiffMT, 3) }}</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDecimal(data.ullageVoyageNotes[0].blArrivalDiffPercentage, 2) }} %</p>
                  </div>
                  <div class="col-1 font-bold">
                    <p>B/L / Arrival</p>
                  </div>
                  <div class="col-1 font-bold mid-el">
                    <p>UTI/MMC N°</p>
                  </div>
                  <div class="col-1">
                    <p>{{ data.ullageVoyageNotes[0].otherUTINumber }}</p>
                  </div>
                  <div class="col-1 font-bold">
                    <p>Calib. Date</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDate(data.ullageVoyageNotes[0].otherUTICalibrationDate) }}</p>
                  </div>
                  <div class="col-1 font-bold">
                    <p>Vessel</p>
                  </div>

                  <!--row 3-->
                  <div class="col-1 font-bold">
                    <p>Ship's Figure on Departure</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDecimal(data.ullageVoyageNotes[0].departureWeight, 3) }}</p>
                  </div>
                  <div class="col-1">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[3]?.note }}</p>
                  </div>
                  <div class="col-1">
                    <p>M/T {{ data.ullageVoyageNotes[0].withVEF ? 'Vef Applied' : 'Vef not Applied' }}</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDecimal(data.ullageVoyageNotes[0].departureArrivalDiffMT, 3) }}</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDecimal(data.ullageVoyageNotes[0].departureArrivalDiffPercentage, 2) }} %</p>
                  </div>
                  <div class="col-1 font-bold">
                    <p>Departure / Arrival</p>
                  </div>
                  <div class="col-1 font-bold mid-el">
                    <p>Sea Conditions</p>
                  </div>
                  <div class="col-4">
                    <p>{{ data.ullageVoyageNotes[0].seaConditions }}</p>
                  </div>


                  <!--row 4-->
                  <div class="col-1 font-bold">
                    <p>Ship's Figure on Arrival</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDecimal(data.ullageVoyageNotes[0].withVEF ?
                      data.ullageVoyageNotes[0].arrivalWeightVEF : data.ullageVoyageNotes[0].arrivalWeightNoVEF, 3)
                    }}</p>
                  </div>
                  <div class="col-1">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[4]?.note }}</p>
                  </div>
                  <div class="col-1">
                    <p>M/T {{ data.ullageVoyageNotes[0].withVEF ? 'Vef Applied' : 'Vef not Applied' }}</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDecimal(data.ullageVoyageNotes[0].blDepartureDiffMT, 3) }}</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDecimal(data.ullageVoyageNotes[0].blDepartureDiffPercentage, 2) }} %</p>
                  </div>
                  <div class="col-1 font-bold">
                    <p>B/L / Departure</p>
                  </div>
                  <div class="col-5 mid-el">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[1]?.note }}</p>
                  </div>
                </div>
              </div>
              <div v-else-if="data.chargeDischargeFlag == 'C'">
                <div class="grid note-grid">
                  <!--row 1-->
                  <div class="col-1 font-bold">
                    <p>Note</p>
                  </div>
                  <div class="col-5">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[0].note }}</p>
                  </div>
                  <div class="col-2 font-bold mid-el">
                    <p>UTI/MMC N°</p>
                  </div>
                  <div class="col-1">
                    <p>{{ data.ullageVoyageNotes[0].surveyorUTINumber }}</p>
                  </div>
                  <div class="col-1 font-bold">
                    <p>Calib. Date</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDate(data.ullageVoyageNotes[0].surveyorUTICalibrationDate) }}</p>
                  </div>
                  <div class="col-1 font-bold">
                    <p>Surveyor</p>
                  </div>
                  <!--row 2-->
                  <div class="col-3">
                    <p>{{ utils.formatDecimal(data.ullageVoyageNotes[0].arrivalWeightVEF, 3) }}</p>
                  </div>
                  <div class="col-3 font-bold">
                    <p>M/T VEF applied</p>
                  </div>
                  <div class="col-2 font-bold mid-el">
                    <p>UTI/MMC N°</p>
                  </div>
                  <div class="col-1">
                    <p>{{ data.ullageVoyageNotes[0].otherUTINumber }}</p>
                  </div>
                  <div class="col-1 font-bold">
                    <p>Calib. Date</p>
                  </div>
                  <div class="col-1">
                    <p>{{ utils.formatDate(data.ullageVoyageNotes[0].otherUTICalibrationDate) }}</p>
                  </div>
                  <div class="col-1 font-bold">
                    <p>Vessel</p>
                  </div>
                  
                  <!--row 3-->
                  <div class="col-3 ">
                    <p>{{ utils.formatDecimal(data.ullageVoyageNotes[0].arrivalWeightNoVEF, 3) }}</p>
                  </div>
                  <div class="col-3 font-bold">
                    <p>M/T VEF not applied</p>
                  </div>
                  <div class="col-2 font-bold mid-el">
                    <p>Sea Conditions</p>
                  </div>
                  <div class="col-4">
                    <p>{{ data.ullageVoyageNotes[0].seaConditions }}</p>
                  </div>
                  
                  <!--row 4-->
                  <div class="col-6">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[1].note }}</p>
                  </div>
                  <div class="col-6 font-bold mid-el">
                    <p>{{ data.ullageVoyageNotes[0].ullageVoyageNoteDetails[2].note }}</p>
                  </div>
                </div>
              </div>
            </template>
          </Card>
        </div>
      </div>
    </div>
  </main>
</template>

<style>
.note-grid {
  border: 1px solid lightgray;

}

.note-grid>div {
  border: 1px solid #e9ecef;
}

.note-grid>.mid-el {
  border-left: 1px solid lightgray;
}
</style>